import { render, staticRenderFns } from "./ProductionCommentCellRenderer.vue?vue&type=template&id=3fd81f4a&scoped=true&lang=pug&"
import script from "./ProductionCommentCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./ProductionCommentCellRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionCommentCellRenderer.vue?vue&type=style&index=0&id=3fd81f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd81f4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
